<template>
  <div>
    <h5 class="header-stripe">
      <span>{{$t('INDENT_MARK_AS_DELIVERED')}}</span>
      <div class="action">
        <Button type="secondary" size="mini" @click="$emit('cancelAction')">{{$t('INDENT_CANCEL')}}</Button>
        <Button type="primary" size="mini" @click="deliverIndent">{{$t('INDENT_SUBMIT')}}</Button>
      </div>
    </h5>
    <div class="row-edit my-10">
      <div class="row-edit-badge">
        <div class="row-edit-badge-section">
          <Rows v-for="(itr, index) in deliveryData" :key="index">
            <div>
              <Row :gutter="10" type="flex" class="mx-0 p-0">
                <Col :span="8" class="pointer pt-15">
                  <Checkbox
                  :disabled="disabled(itr)"
                  :checked="disabled(itr) || setReleaseReach(itr)"
                  v-model="selected[index]">
                  <Ellipsis v-if="itr.gateLabel" :text="itr.gateLabel" :length="20"/>
                  <Ellipsis v-else-if="itr.gate_name" :text="itr.gate_name" :length="20"/>
                  <Ellipsis v-else-if="!itr.gate_name" :text="itr.name" :length="20"/>
                  <Tooltip class="item" effect="dark" placement="bottom-end" v-if="disableIfLRNotAvailable(itr)">
                    <div slot="content" class="tooltipcontent">{{$t('INDENT_LR_ATTACHMENT_MISSING')}}</div>
                    <svgicon name="icon-warning-circle" class="text-red" width="12" height="13" />
                  </Tooltip>
                </Checkbox>
              </Col>
              <Col :span="16">
                <Form :inline="true" class="form-default form-multi mb-20">
                  <FormItem :label="$t('INDENT_REPORTED_AT')">
                    <Date-Picker
                    :clearable="itr.reported_at ? false:true"
                    :picker-options="arrivedOption()"
                    :value="fillReportedAt(itr) || ''"
                    :disabled="(disabled(itr) || autoReachRelease(itr))"
                    :format="datePickerFormat"
                    type="datetime"
                    :key="index"
                    :default-time="defaultTime"
                    :placeholder="$t('INDENT_SELECT_DATE_AND_TIME')"
                    :prefix-icon="checkGeofenceArrivedPopulated(itr)"
                    @input="changeReportedDate($event, itr.destination_id, itr.gate_id)"
                    class="w175"/>
                  </FormItem>
                  <FormItem :label="$t('INDENT_POD_DATE')">
                    <Date-Picker
                    :clearable="itr.release_at ? false:true"
                    :picker-options="releaseOption(itr)"
                    :value="fillDispatchedAt(itr) || ''"
                    :disabled="disabled(itr) || isLrRequired(itr)"
                    :format="datePickerFormat"
                    type="datetime"
                    :key="index"
                    :default-time="defaultTime"
                    :placeholder="$t('INDENT_SELECT_DATE_AND_TIME')"
                    :prefix-icon="checkGeofenceDispatchedPopulated(itr)"
                    @input="changePODDate($event, itr.destination_id, itr.gate_id)"
                    class="w175"/>
                  </FormItem>
                  <div v-if="selected[index]">
                    <FormItem :label="$t('INDENT_UNLODING_START_AT')">
                      <Date-Picker
                      :clearable="itr.unloading_start_at ? false : true"
                      :picker-options="arrivedOption()"
                      :value="fillUnloadingStartAt(itr) || ''"
                      :disabled="(disabled(itr) || autoReachRelease(itr))"
                      :format="datePickerFormat"
                      type="datetime"
                      :key="index"
                      :default-time="defaultTime"
                      :placeholder="$t('INDENT_SELECT_DATE_AND_TIME')"
                      :prefix-icon="checkGeofenceDispatchedPopulated(itr)"
                      @input="changeUnloadingDate($event, itr.destination_id, itr.gate_id)"
                      class="w175"/>
                    </FormItem>
                    <FormItem :label="$t('INDENT_UNLOADING_END_AT')">
                      <Date-Picker
                      :clearable="itr.unloading_end_at ? false : true"
                      :picker-options="releaseOption(itr)"
                      :value="fillUnloadingEndAt(itr) || ''"
                      :disabled="disabled(itr) || isLrRequired(itr)"
                      :format="datePickerFormat"
                      type="datetime"
                      :key="index"
                      :default-time="defaultTime"
                      :placeholder="$t('INDENT_SELECT_DATE_AND_TIME')"
                      :prefix-icon="checkGeofenceDispatchedPopulated(itr)"
                      @input="changeUnloadedDate($event, itr.destination_id, itr.gate_id)"
                      class="w175"/>
                    </FormItem>
                  </div>
                </Form>
              </Col>
            </Row>
          </div>
        </Rows>
      </div>
    </div>
  </div>
    <div class="d-block text-xs" v-if="isAnyGeofenceDatePopulated">
      <strong>{{$t('INDENT_NOTE')}} :</strong>
      {{$t('INDENT_REPORTED_POD_TIME_DEFAULTS_TO_GEO_FENCE_TIME')}}
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { movementMapLower } from 'pando-constants';

export default {
  created() {
    const res = [];
    this.drops.map((item) => {
      const gateId = item.gate_id ? item.gate_id : null;
      const gate = item.address.gates ? item.address.gates.find(_gate => _gate._id.toString() === item.gate_id.toString()) : null;
      const gateName = gate ? `${gate.reference_id} - ${item.address.name}` : '';
      const gateRefId = gate ? gate.reference_id : '';
      const currentGate = (item && item.gate_id && item.location_id) ? this.$depot.gate(item.gate_id, item.location_id) : {};
      const obj = {
        gate_id: gateId,
        name: item.address.name,
        destination_id: item.address._id,
        db_reported_at: item.reported_at,
        db_release_at: item.release_at,
        reported_at: item.reported_at,
        release_at: item.release_at,
        unloading_start_at: item.unloading_start_at,
        unloading_end_at: item.unloading_end_at,
        geofence_entry_time: item.geofence_entry_time,
        geofence_exit_time: item.geofence_exit_time,
        lr_available: item.lr_attachment_ids.length,
        location_id: item.location_id,
        isStorageLocation: currentGate.is_storage_location || false,
        gate,
        gateLabel: item.address.name || gateRefId ? ` ${item.address.name} - ${gateRefId}` : '',
      };
      if (this.configurations.multi_drop_at_gate_level) {
        obj.gate_name = gateName;
        obj.gateLabel = gateName || gateRefId ? ` ${gateName} - ${gateRefId}` : '';
      }
      res.push(obj);
    });
    const flags = {};
    let uniqueField = 'destination_id';
    if (this.configurations.multi_drop_at_gate_level) {
      uniqueField = 'gate_id';
    }
    const unique = res.filter((entry) => {
      if (this.configurations.multi_drop_at_gate_level) {
        if (flags[`${entry.destination_id}_${entry.gate_id}`]) {
          return false;
        }
        flags[`${entry.destination_id}_${entry.gate_id}`] = true;
        return true;
      }
      if (flags[entry[uniqueField]]) {
        return false;
      }
      flags[entry[uniqueField]] = true;
      return true;
    });
    unique.forEach((element, index) => {
      element.index = index;
      if (this.disabled(element)) {
        this.selected[element.index] = true;
      } else {
        this.selected[element.index] = false;
      }
    });
    if (this.isStorageLocation) {
      this.deliveryData = this.storageLocationGroup(unique);
    } else {
      this.deliveryData = unique;
    }
    this.deliveryData.forEach((element) => {
      if (element.destination_id) {
        if (this.fillReportedAt(element)) {
          element.reported_at = this.fillReportedAt(element);
        }
        if (this.fillDispatchedAt(element)) {
          element.release_at = this.fillDispatchedAt(element);
        }
        if (this.fillUnloadingStartAt(element)) {
          element.unloading_start_at = this.fillUnloadingStartAt(element);
        }
        if (this.fillUnloadingEndAt(element)) {
          element.unloading_end_at = this.fillUnloadingEndAt(element);
        }
        this.selected[element.index] = true;
      }
    },
    );
    this.isAnyGeofenceDatePopulated = this.deliveryData.some(element => this.isGeofenceDatePopulated(element, element.reported_at, element.release_at));
  },
  computed: {
    ...mapGetters({
      configurations: 'app/currentClientConfig',
    }),
    isStorageLocation() {
      return this.$hasFeature('enable_storage_location') || false;
    },
    fillReportedAt() {
      return (consignee) => {
        if (consignee.reported_at) {
          return new Date(consignee.reported_at);
        }
        if (this.getGeofenceReportedAt(consignee)) {
          return new Date(consignee.geofence_entry_time);
        }
        return '';
      };
    },
    fillDispatchedAt() {
      return (consignee) => {
        if (consignee.release_at) {
          return new Date(consignee.release_at);
        }
        if (this.getGeofenceDispatchedAt(consignee)) {
          return new Date(consignee.geofence_exit_time);
        }
        return '';
      };
    },
    fillUnloadingStartAt() {
      return (consignee) => {
        if (consignee.unloading_start_at) {
          return new Date(consignee.unloading_start_at);
        }
        return '';
      };
    },
    fillUnloadingEndAt() {
      return (consignee) => {
        if (consignee.unloading_end_at) {
          return new Date(consignee.unloading_end_at);
        }
        return '';
      };
    },
    getGeofenceReportedAt() {
      return consignee => (this.configurations.autopopulate_geofence_time ?
        consignee.geofence_entry_time : null);
    },
    getGeofenceDispatchedAt() {
      return consignee => (this.configurations.autopopulate_geofence_time ?
        consignee.geofence_exit_time : null);
    },
    checkGeofenceArrivedPopulated() {
      return (element) => {
        if (element && this.isArrivedGeofenceDatePopulated(element, element.reported_at)) {
          return 'icon-location';
        }
        return 'el-icon-date';
      };
    },
    checkGeofenceDispatchedPopulated() {
      return (element) => {
        if (element && this.isDispatchedGeofenceDatePopulated(element, element.release_at)) {
          return 'icon-location';
        }
        return 'el-icon-date';
      };
    },
  },
  props: {
    drops: {
      type: Array,
      default: () => [],
    },
    getBackDateConfig: {
      type: Object,
      default: () => {},
    },
    dispatchDate: {
      type: Date,
    },
    movement: {
      type: Number,
    },
    datePickerFormat: {
      type: String,
      default: 'dd-MM-yyyy hh:mm A',
    },
    sources: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const currentDate = new Date();
    return {
      input: '',
      deliveryData: [],
      selected: [],
      isAnyGeofenceDatePopulated: false,
      defaultTime: `${currentDate.getHours()}:${currentDate.getMinutes()}:00`,
    };
  },
  methods: {
    storageLocationGroup(gateWiseGroup) {
      const {
        groupedStorage,
        nonStorageItems,
      } = gateWiseGroup.reduce(
        (acc, item) => {
          if (item.isStorageLocation) {
            const locId = item.location_id.toString() || '';

            if (!acc.groupedStorage[locId]) {
              acc.groupedStorage[locId] = {
                items: [],
                names: [],
                ids: [],
                lr_available: [],
              };
            }
            acc.groupedStorage[locId].items.push(item);
            acc.groupedStorage[locId].names.push(item.gate.reference_id || '');
            acc.groupedStorage[locId].names.push(item.lr_available);
            acc.groupedStorage[locId].ids.push(item.gate_id.toString());
          } else {
            acc.nonStorageItems.push(item);
          }
          return acc;
        },
        {
          groupedStorage: {},
          nonStorageItems: [],
        },
      );
        // Build combined storage entries per location_id
      const combinedStorageObjects = Object.values(groupedStorage).map(group => ({
        ...group.items[0], // use first as base
        lr_available: group.lr_available.every(Boolean),
        gateLabel: `${group.items[0].gate.city} - ${group.names.join(',')} Storage Location`,
        combined_storage_gate_ids: group.ids.join(','),
      }));

      const final = [...combinedStorageObjects, ...nonStorageItems];
      return final;
    },
    disableIfLRNotAvailable(itr) {
      return !itr.lr_available && this.configurations.is_lr_mandatory_for_mark_as_delivered && this.movement &&
        this.configurations.is_lr_mandatory_for_mark_as_delivered[movementMapLower[this.movement]];
    },
    maxGateTruckOut() {
      return new Date(
        this.$moment.max(
          this.sources.map(_sources => this.$moment(_sources.dispatched_at)),
        ),
      );
    },
    arrivedOption() {
      const truckDispatched = this.dispatchDate;
      const reportedDateAllow = this.getBackDateConfig.reported_date;
      return {
        disabledDate(time) {
          if (reportedDateAllow) {
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date();
          }
          return time.getTime() > Date.now() ||
            time.getTime() < new Date(truckDispatched).getTime() - 8.64e7;
        },
      };
    },
    releaseOption(consignee) {
      const dispatch = consignee.arrived_at;
      const truckDispatched = this.dispatchDate;
      const releaseDateAllow = this.getBackDateConfig.release_date;
      return {
        disabledDate(time) {
          if (releaseDateAllow) {
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date();
          }
          if (!dispatch) {
            return time.getTime() > Date.now() ||
              time.getTime() < new Date(truckDispatched).getTime() - 8.64e7;
          }
          return time.getTime() > new Date() ||
            time.getTime() < new Date(dispatch).getTime() - 8.64e7;
        },
      };
    },
    autoReachRelease(key) {
      const destination = this.drops.find(element =>
        element.address._id === key.destination_id);
      return (this.configurations &&
      this.configurations.track_settings
      && this.configurations.track_settings.consignee_auto_reach_release
        && !!destination.reported_at);
    },
    changeReportedDate(data, destinationId, gateId) {
      this.deliveryData.forEach((element) => {
        if (element.destination_id === destinationId) {
          if (gateId) {
            if (element.gate_id === gateId) {
              element.reported_at = data;
              if (!element.unloading_start_at || isNaN(element.unloading_start_at)) {
                element.unloading_start_at = element.reported_at;
              }
              this.selected[element.index] = true;
            }
          } else {
            element.reported_at = data;
            this.selected[element.index] = true;
          }
        }
      });
      this.isAnyGeofenceDatePopulated = this.deliveryData.some(element => this.isGeofenceDatePopulated(element, element.reported_at, element.release_at));
    },
    changePODDate(data, destinationId, gateId) {
      this.deliveryData.forEach((element) => {
        if (element.destination_id === destinationId) {
          if (gateId) {
            if (element.gate_id === gateId) {
              element.release_at = data;
              if (!element.unloading_end_at || isNaN(element.unloading_end_at)) {
                element.unloading_end_at = element.release_at;
              }
              this.selected[element.index] = true;
            }
          } else {
            element.release_at = data;
            this.selected[element.index] = true;
          }
        }
      });
      this.isAnyGeofenceDatePopulated = this.deliveryData.some(element => this.isGeofenceDatePopulated(element, element.reported_at, element.release_at));
    },
    changeUnloadingDate(data, destinationId, gateId) {
      this.deliveryData.forEach((element) => {
        if (element.destination_id === destinationId) {
          if (gateId) {
            if (element.gate_id === gateId) {
              element.unloading_start_at = data;
              this.selected[element.index] = true;
            }
          } else {
            element.unloading_start_at = data;
            this.selected[element.index] = true;
          }
        }
      });
    },
    changeUnloadedDate(data, destinationId, gateId) {
      this.deliveryData.forEach((element) => {
        if (element.destination_id === destinationId) {
          if (gateId) {
            if (element.gate_id === gateId) {
              element.unloading_end_at = data;
              this.selected[element.index] = true;
            }
          } else {
            element.unloading_end_at = data;
            this.selected[element.index] = true;
          }
        }
      });
    },
    isGeofenceDatePopulated(consignee, arrived, dispatched) {
      if (this.configurations.autopopulate_geofence_time) {
        if ((!consignee.db_reported_at && !!consignee.geofence_entry_time) ||
         (!consignee.db_release_at && !!consignee.geofence_exit_time)) {
          if (new Date(arrived).getTime() === new Date(consignee.geofence_entry_time).getTime() ||
              new Date(dispatched).getTime() === new Date(consignee.geofence_exit_time).getTime()) {
            return true;
          }
        }
      }
      return false;
    },
    isArrivedGeofenceDatePopulated(consignee, arrived) {
      if (this.configurations.autopopulate_geofence_time) {
        if (!consignee.db_reported_at && !!consignee.geofence_entry_time) {
          if (new Date(arrived).getTime() === new Date(consignee.geofence_entry_time).getTime()) {
            return true;
          }
        }
      }
      return false;
    },
    isDispatchedGeofenceDatePopulated(consignee, dispatched) {
      if (this.configurations.autopopulate_geofence_time) {
        if (!consignee.db_release_at && !!consignee.geofence_exit_time) {
          if (new Date(dispatched).getTime() === new Date(consignee.geofence_exit_time).getTime()) {
            return true;
          }
        }
      }
      return false;
    },
    isLrRequired(key) {
      if (this.configurations
        .is_lr_mandatory_for_mark_as_delivered[movementMapLower[this.movement]]) {
        const destination = this.deliveryData.find((element) => {
          if (element.gate_id && this.configurations.multi_drop_at_gate_level) {
            return element.gate_id === key.gate_id;
          }
          return element.location_id === key.location_id;
        });
        return !(destination.lr_available);
      }
      return false;
    },
    disabled(key) {
      let destination = this.drops.find(element =>
        element.address._id === key.destination_id);
      if (destination.gate_id && this.configurations.multi_drop_at_gate_level) {
        destination = this.drops.find(element =>
          element.gate_id === key.gate_id);
      }
      return !!(destination.reported_at && destination.release_at);
    },
    setReleaseReach(key) {
      let destination = this.deliveryData.find(element =>
        element.destination_id === key.destination_id);
      if (destination.gate_id && this.configurations.multi_drop_at_gate_level) {
        destination = this.deliveryData.find(element =>
          element.gate_id === key.gate_id);
      }
      return !!(destination.reported_at && destination.release_at);
    },
    getGateWiseDestinationGroup(element, gateId) {
      return {
        destination_id: element.destination_id,
        release_at: element.release_at,
        reported_at: element.reported_at,
        unloading_start_at: element.unloading_start_at,
        unloading_end_at: element.unloading_end_at,
        ...(gateId) ? { gate_id: gateId } : {},
      };
    },
    async deliverIndent() {
      const maxGateTruckOut = this.maxGateTruckOut();
      if (this.deliveryData.some(source => new Date(source.reported_at).getTime() > new Date().getTime()) ||
          this.deliveryData.some(source => new Date(source.release_at).getTime() > new Date().getTime())) {
        this.$errorMessage({ message: this.$t('INDENT_REPORTED_RELEASE_FUTURE_TIME_ERROR_MSG') });
        this.toggleback();
        return;
      }
      if (this.deliveryData.some(source => new Date(source.reported_at).getTime() < maxGateTruckOut.getTime())) {
        this.$errorMessage({ message: this.$t('INDENT_REPORTED_AFTER_DISPATCHED_ERROR_MSG') });
        this.toggleback();
        return;
      }
      if (this.deliveryData.some(source => new Date(source.release_at).getTime() < maxGateTruckOut.getTime())) {
        this.$errorMessage({ message: this.$t('INDENT_RELEASE_AFTER_DISPATCHED_ERROR_MSG') });
        this.toggleback();
        return;
      }
      if (this.deliveryData.some(source => new Date(source.release_at).getTime() < new Date(source.reported_at).getTime())) {
        this.$errorMessage({ message: this.$t('INDENT_RELEASE_AFTER_REPORTED_ERROR_MSG') });
        this.toggleback();
        return;
      }
      if (this.deliveryData.some(source => source.unloading_start_at > source.release_at ||
        source.unloading_start_at < source.reported_at)) {
        this.$errorMessage({ message: this.$t('INDENT_UNLOADING_START_BTWN_REPORTED_RELEASE') });
        this.toggleback();
        return;
      }
      if (this.deliveryData.some(source => source.unloading_end_at < source.unloading_start_at ||
        source.unloading_end_at > source.release_at)) {
        this.$errorMessage({ message: this.$t('INDENT_UNLOADING_END_BTWN_UNLOADING_START_RELEASE') });
        this.toggleback();
        return;
      }
      const data = [];
      this.deliveryData.forEach((element) => {
        if (this.selected[element.index] && (element.release_at || element.reported_at)) {
          if (this.isStorageLocation) {
            if (element.isStorageLocation) {
              const gateIds = element.combined_storage_gate_ids.split(',');
              gateIds.forEach((gateId) => {
                data.push(this.getGateWiseDestinationGroup(element, gateId));
              });
            } else {
              const gateId = this.configurations.multi_drop_at_gate_level ? element.gate_id : '';
              data.push(this.getGateWiseDestinationGroup(element, gateId));
            }
          } else {
            const gateId = this.configurations.multi_drop_at_gate_level ? element.gate_id : '';
            data.push(this.getGateWiseDestinationGroup(element, gateId));
          }
        }
      });
      if (data.length) {
        this.$emit('markDeliver', data);
      }
    },
  },
};
</script>
